import getApi from '../../../api'
import { InsiIdentityCheckPayload, InsiRestIdentityCheckResponse } from '../../../model/Insi'

export const checkPatientIdentity = (payload: InsiIdentityCheckPayload) =>
  getApi().post<InsiRestIdentityCheckResponse>('/insi/patients', payload)
